import { render, staticRenderFns } from "./superAdminLayout.vue?vue&type=template&id=63f3c940&scoped=true&"
import script from "./superAdminLayout.vue?vue&type=script&lang=js&"
export * from "./superAdminLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f3c940",
  null
  
)

export default component.exports